import React, { useState, useEffect } from "react";
import { Row, Col, Select, Button, Input, DatePicker, message, TimePicker } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import "./DataFilter.css";
import * as _ from "lodash";
import { returnDataArrayObject } from "../../../../../utils/arrayHelper";
import {
  DATE_FORMAT,
  DATE_WITH_HOUR_FORMAT,
  DATE_WITH_HOUR_MINUTES_FORMAT,
} from "../../../../../constants/dateConstants";
import NotFound from "../../../../../components/NotFound";
import { updateDataFilters, updateResourceSourceAndFilter, deleteFilters } from "../../../../../redux/editorSlice";
import moment from "moment";
import { customDateTimeFormat } from "../../../../../utils/filterHelper";
import DeleteIcon from "../../../../../assets/icons/delete-icon.svg";
const { Option } = Select;

/* The panel is 300px wide, so a Select popup constrained to its trigger truncates
   "Greater Than Or Equal" to "Greate...". Letting the popup size itself keeps the
   options readable without widening the column. */
const WIDE_DROPDOWN = { minWidth: 190 };

/* Defaults for a global filter that has no config yet. Kept in one place because the
   creation path and the load path used to disagree - text got maxLength 100 when you
   picked the type and 20 when you reopened the panel. */
function defaultConfigFor(dataType) {
  if (dataType === "number") return { min: 0, max: 10000 };
  if (dataType === "date") return { range: "dynamic", value: "LastMonth" };
  return { maxLength: 100 };
}

/* Data type of a column, from the resource's fields. Returns undefined rather than
   throwing when the column is gone. */
function findFieldDataType(selectedResource, fieldName) {
  const field =
    selectedResource?.availableFields?.find((af) => af?.fieldName === fieldName) ??
    selectedResource?.allFields?.find((af) => af?.fieldName === fieldName);
  return field?.dataType;
}

/* Which operators a data filter can use. Strings can only be matched or searched;
   ordering operators need a comparable type. */
function filterTypesFor(dataType) {
  return dataType === "string" ? ["equal", "con"] : ["equal", "lt", "gt", "lte", "gte", "between"];
}

export default function DataFilter(props) {
  const [dataFilters, setDataFilters] = useState([]);
  const [definedFilters, setDefinedFilters] = useState([]);
  const [fields, setFields] = useState([]);
  // const [selectedResource, setSelectedResource] = useState(null);
  // const [reportDataStatus, setReportDataStatus] = useState('default');
  const dateTimeFormatChange = customDateTimeFormat(props.selectedResource.availableFields);

  const dispatch = useDispatch();

  const setDataFiltertem = () => {
    let currentFilters = [...dataFilters];
    currentFilters.push({
      id: Date.now(),
      dataType: "string",
      filterType: "equal",
    });
    setDataFilters(currentFilters);
  };

  const deleteDataFilterItem = (item) => {
    setDataFilters(dataFilters.filter((f) => f.id !== item.id));
    dispatch(
      deleteFilters({
        id: item.id,
        filterType: "dataFilters",
      }),
    );
  };

  // useEffect(() => {
  //   let currentFilters = dataFilters.map((df) => {
  //     return {
  //       id: df.id,
  //       fieldName: df.fieldName,
  //       displayName: df.displayName,
  //       dataType: df.dataType,
  //       filterType: df.dataType==='string'? 'equal' : df.filterType,
  //       value: df.value ? df.value : null,
  //       value1: df.value1 ? df.value1 : null,
  //       value2: df.value2 ? df.value2 : null,
  //     };
  //   })
  //   setDataFilters(currentFilters)
  // }, [dataFilters])

  useEffect(() => {
    console.log("availableFields changed", props.selectedResource.dataFilters);
    let currentFilters = (props?.selectedResource?.dataFilters || []).map((df) => {
      return {
        id: df.id,
        fieldName: df.fieldName,
        displayName: df.displayName,
        /* Was: availableFields.find(...)["dataType"] with no guard on the result, so
           opening this panel threw as soon as a saved filter pointed at a column that
           had since been removed from the resource. */
        dataType: df.dataType || findFieldDataType(props?.selectedResource, df.fieldName) || "text",
        filterType: df.filterType,
        value: df.value ? df.value : null,
        value1: df.value1 ? df.value1 : null,
        value2: df.value2 ? df.value2 : null,
      };
    });

    const currentDefinedFilters = (props?.selectedResource?.customFilters || []).map((df) => {
      return {
        id: df.id,
        parameterType: df.parameterType,
        parameterName: df.parameterName,
        dataType: df.dataType,
        value: df.value,
        /* Was: config rebuilt from dataType with hardcoded constants, which threw away
           whatever was saved - every reopen reset Min/Max/Max Length and forced the date
           range back to LastMonth. Now the saved config wins and the defaults are only a
           fallback for filters that have none. */
        config: _.isEmpty(df.config) ? defaultConfigFor(df.dataType) : df.config,
      };
    });

    setDefinedFilters(currentDefinedFilters);
    setDataFilters(currentFilters);
  }, [props.selectedResource.availableFields]);

  const updateDataFilter = (item, key, val) => {
    // let currentFilters = [...dataFilters];
    // let updatedFilter = Object.assign(item, { [key]: val });

    // // updatedFilter[key] = val
    // currentFilters[currentFilters.indexOf(f => f.id === item.id)] = updatedFilter
    let currentFilters = dataFilters.map((df) => {
      if (df?.id !== item?.id) return { ...df };

      const nextDataType =
        key === "dataType"
          ? val
          : key === "fieldName"
            ? (findFieldDataType(props?.selectedResource, val) ?? df.dataType)
            : df.dataType;

      /* Changing the type invalidates what came before it: "Greater Than" makes no
         sense on a string, and a date string left in a number filter would be saved
         and shipped to the runtime as-is. Both are reset rather than carried over. */
      const typeChanged = nextDataType !== df.dataType;
      const allowed = filterTypesFor(nextDataType);
      const requestedType = key === "filterType" ? val : df.filterType;

      return {
        id: df.id,
        fieldName: key === "fieldName" ? val : df?.fieldName,
        displayName: key === "displayName" ? val : df?.displayName,
        dataType: nextDataType,
        filterType: allowed.includes(requestedType) ? requestedType : "equal",
        value: key === "value" ? val : typeChanged ? null : (df.value ?? null),
        value1: key === "value1" ? val : typeChanged ? null : (df.value1 ?? null),
        value2: key === "value2" ? val : typeChanged ? null : (df.value2 ?? null),
      };
    });

    setDataFilters(currentFilters);
  };

  const setDefinedFiltertem = () => {
    let currentFilters = [...definedFilters];
    currentFilters.push({
      id: Date.now(),
      parameterType: "body",
      parameterName: "",
      dataType: "text",
      config: {},
    });
    setDefinedFilters(currentFilters);
  };

  const deleteDefinedFilterItem = (item) => {
    setDefinedFilters(definedFilters.filter((f) => f.id !== item.id));
    dispatch(
      deleteFilters({
        id: item.id,
        filterType: "customFilters",
      }),
    );
  };

  const updateDefinedFilter = (item, key, val) => {
    // let currentFilters = [...definedFilters];
    // let updatedFilter = Object.assign(item, { [key]: val });

    // // updatedFilter[key] = val
    // currentFilters[currentFilters.indexOf(f => f.id === item.id)] = updatedFilter

    /* Rewritten. The old nested-ternary chain could only ever write config when the
       dataType key changed, which is why Min / Max / Max Length were unreachable, and
       it dropped `value` entirely (see the commented-out branch below) so editing any
       field wiped a value that was already set. */
    let currentFilters = definedFilters.map((df) => {
      if (df.id !== item.id) return { ...df };

      const next = { ...df, [key]: val };

      if (key === "dataType") {
        // A config for the old type means nothing to the new one.
        next.config = defaultConfigFor(val);
        next.value = null;
      } else if (key === "min" || key === "max" || key === "maxLength") {
        /* These are bounds the runtime compares against, so they are stored as numbers -
           an input always hands back a string, and "10" > "9" is false. */
        next.config = { ...df.config, [key]: val === "" || val === null ? null : Number(val) };
        delete next[key];
      } else if (key === "dynamicDateRange") {
        /* Switching between a rolling window and a fixed date: the two carry different
           payloads in config.value, so it is reset to that mode's default. */
        next.config = { range: val, value: val === "dynamic" ? "LastMonth" : null };
        delete next[key];
      } else if (key === "dynamicDateRangeValue") {
        next.config = { ...df.config, range: df.config?.range || "dynamic", value: val };
        delete next[key];
      }

      return next;
    });

    // value:
    //   df.id === item.id && key === "value"
    //     ? df.dataType === "number"
    //       ? Number(val)
    //       : df.dataType === "date" ?
    //         moment(val).format("yyyy-MM-DD[T]HH:mm:ss.SSSZ")
    //         : val
    //     : df.dataType === "number"
    //       ? Number(df.value)
    //       : df.value,

    setDefinedFilters(currentFilters);
  };

  // useEffect(() => {
  //     dispatch(updateDataFilters(dataFilters))
  // }, [dataFilters]);

  const saveFilters = (filterArray, customFilters) => {
    console.log("Save FILTERS", customFilters);

    /* A row with no field picked saved as fieldName: undefined and then silently did
       nothing at runtime - the host has no column to attach it to. Same for a global
       filter with no parameter name: it cannot be put in a request. Say so instead of
       writing a filter that can never fire. */
    if (filterArray.some((f) => !f.fieldName)) {
      message.error("Every data filter needs a field name.");
      return;
    }

    if (customFilters.some((f) => !f.parameterName)) {
      message.error("Every global filter needs a parameter name.");
      return;
    }

    if (customFilters && customFilters.length > 0) {
      console.log("APPLY FILTERS customFilters");
      fetchReportData(filterArray, customFilters)
        .then((res) => message.info("Filters successfully saved!"))
        .catch((err) => console.log(err));
      // dispatch(updateDataFilters({ definedFilters: definedFilters, filterArray: filterArray }))
    } else {
      dispatch(updateDataFilters({ dataFilters: filterArray, applyFilters: true }));
      message.info("Filters successfully saved!");
    }
  };

  const clearFilters = () => {
    dispatch(updateDataFilters({ dataFilters: [], customFilters: [], applyFilters: false }));
    setDataFilters([]);
    /* Was missing, so Reset cleared redux but left the global rows on screen - and
       pressing Save again wrote them straight back. */
    setDefinedFilters([]);
    message.info("Filters successfully cleared!");
    fetchReportData([], []);
    //     .then((res) => message.info("Filters successfully cleared!"))
    //     .catch((err) => console.log(err));
  };

  async function fetchReportData(filterArray, customFilters) {
    // console.log(" fetchReportData===>>>>", resources.selectedResource)
    const selectedResource = props.selectedResource;

    const payload = {
      selectedResource: Object.assign(selectedResource),
      // reportData: reportData,
      customFilters: customFilters,
      dataFilters: filterArray,
    };

    dispatch(updateResourceSourceAndFilter(payload));
    // if (
    //   selectedResource &&
    //   selectedResource.source &&
    //   selectedResource.source.resoueceType === "Rest API"
    // ) {
    //   // const response = await axios.get(resources.selectedResource.connectionData.baseUrl);
    //   // console.log(" fetchReportData===>>>>", selectedResource.source)
    //   try {
    //     const requestValues =
    //       selectedResource.source.connectionData.requestValues;
    //     const authInfo =
    //       selectedResource &&
    //       selectedResource.source.connectionData &&
    //       selectedResource.source.connectionData.authInfo;
    //     let urlParamSring = "";
    //     if (requestValues.urlParams.length > 0) {
    //       urlParamSring = urlParamSring + "?";
    //       for (let i = 0; i < requestValues.urlParams.length; i++) {
    //         if (
    //           requestValues.urlParams[i]["key"] !== "" &&
    //           requestValues.urlParams[i]["value"] !== ""
    //         ) {
    //           urlParamSring =
    //             urlParamSring +
    //             requestValues.urlParams[i]["key"] +
    //             "=" +
    //             requestValues.urlParams[i]["value"] +
    //             "&";
    //         }
    //       }
    //       urlParamSring.slice(0, -1);
    //     }

    //     let headerObj = {};
    //     if (requestValues.requestHeaders.length > 0) {
    //       for (let i = 0; i < requestValues.requestHeaders.length; i++) {
    //         if (
    //           requestValues.requestHeaders[i]["key"] !== "" &&
    //           requestValues.requestHeaders[i]["value"] !== ""
    //         ) {
    //           headerObj[requestValues.requestHeaders[i]["key"]] =
    //             requestValues.requestHeaders[i]["value"];
    //         }
    //       }
    //     }

    //     let bodyParamObj = {};
    //     // if (requestValues.authParams) {
    //     //     bodyParamObj = Object.assign({}, authParams);
    //     // }
    //     if (requestValues.bodyParams.length > 0) {
    //       for (let i = 0; i < requestValues.bodyParams.length; i++) {
    //         if (
    //           requestValues.bodyParams[i]["key"] !== "" &&
    //           requestValues.bodyParams[i]["value"] !== ""
    //         ) {
    //           bodyParamObj[requestValues.bodyParams[i]["key"]] =
    //             requestValues.bodyParams[i]["value"];
    //         }  else if ( requestValues.bodyParams[i]["key"] !== "" && requestValues.bodyParams[i]["dataType"] === "date") {
    //           if(requestValues.bodyParams[i]["dateConfig"]) {
    //             let dateCf = requestValues.bodyParams[i]["dateConfig"];
    //             if(dateCf.dateOption === "daysBefore") {
    //               let dateVal = moment.utc().subtract(dateCf.timeUnits, 'day').startOf('day').format(dateCf.dateFormat);
    //               bodyParamObj[requestValues.bodyParams[i]["key"]] = dateVal;
    //             } else if (dateCf.dateOption === "today") {
    //               let dateVal = moment().format(dateCf.dateFormat);
    //               bodyParamObj[requestValues.bodyParams[i]["key"]] = dateVal;
    //             }
    //           }
    //         }
    //       }
    //     }
    //     // // await Axios.get(resources.selectedResource.connectionData.baseUrl)
    //     if (customFilters.length > 0) {
    //       customFilters.forEach((element) => {
    //         if (element.parameterName !== "") {
    //           if (element.parameterType === "query") {
    //             if (urlParamSring === "") {
    //               urlParamSring = urlParamSring + "?";
    //             }
    //             urlParamSring =
    //               urlParamSring +
    //               element.parameterName +
    //               "=" +
    //               element.value +
    //               "&";
    //           } else {
    //             bodyParamObj[element.parameterName] = element.value;
    //           }
    //         }
    //       });
    //     }
    //     // setReportDataStatus("pending")
    //     if (authInfo.method === "jwt") {
    //       console.log("JWT PROCESS");
    //       const timestamp = Math.floor(Date.now() / 1000) + 1000;
    //       const privateKey = authInfo.parameters.privateKey;
    //       let userToken=localStorage.getItem('accessToken');
    //       var payload = {
    //         aud: authInfo.parameters.aud,
    //         exp: timestamp,
    //         iss: authInfo.parameters.iss,
    //         userToken: userToken
    //       };
    //       var signOptions = {
    //         algorithm: "RS256",
    //       };

    //       var privateKeyVal = privateKey
    //         ? privateKey.replace(/\\n/g, "\n")
    //         : null;

    //       if (privateKeyVal) {
    //         try {
    //           var token = jwt.sign(payload, privateKeyVal, signOptions);
    //           console.log("Generated JWT authParams=====>>", token);
    //           // setApiTestStatus("success")

    //           await Axios({
    //             method: requestValues.httpMethod,
    //             url:
    //               selectedResource.source.connectionData.baseUrl +
    //               urlParamSring,
    //             data: JSON.parse(JSON.stringify(bodyParamObj)),
    //             headers: {
    //               "Access-Control-Allow-Origin": "*",
    //               "Content-Type": "application/json",
    //               Authorization: `Bearer ` + token,
    //             },
    //           })
    //             .then((response) => {
    //               console.log("CUSTOM FILTER response.data", response);
    //               // setReportDataStatus("success")
    //               const reportData = response.data ? response.data : response;
    //               const payload = {
    //                 selectedResource: Object.assign(selectedResource),
    //                 reportData: reportData,
    //                 customFilters: customFilters,
    //                 dataFilters: filterArray,
    //               };

    //               dispatch(updateResourceSourceAndFilter(payload));
    //               // dispatch(updateResourceSource(Object.assign(selectedResource, { reportData: reportData })))
    //               // dispatch(updateDataFilters({ definedFilters: customFilters, filterArray: filterArray }))
    //             })
    //             .catch((error) => {
    //               // setReportDataStatus("error")

    //               console.log(error);
    //             });
    //         } catch (e) {
    //           console.log("JWT authPsign error=====>>", e);
    //           // setReportDataStatus("error")
    //         }
    //       }
    //     } else {
    //       Axios({
    //         method:
    //           selectedResource.source.connectionData.requestValues.httpMethod,
    //         url: selectedResource.source.connectionData.baseUrl + urlParamSring,
    //         data: bodyParamObj,
    //         headers: headerObj,
    //       })
    //         .then(async (response) => {
    //           console.log("CUSTOM FILTER response.data", response);
    //           // setReportDataStatus("success")
    //           // setReportDataObject(response.data ? response.data : response)
    //           const reportData = response.data ? response.data : response;
    //           const payload = {
    //             selectedResource: Object.assign(selectedResource),
    //             reportData: reportData,
    //             customFilters: customFilters,
    //             dataFilters: filterArray,
    //           };

    //           dispatch(updateResourceSourceAndFilter(payload));
    //           // dispatch(updateDataFilters({ dataFilters: filterArray }))
    //         })
    //         .catch((error) => {
    //           // setReportDataStatus("error")
    //           // setReportDataObject(null)
    //           // console.log(error);
    //         });
    //     }
    //   } catch (error) {
    //     // setReportDataStatus("error")
    //     // setReportDataObject(null)
    //     // console.log(error);
    //   }
    // }
  }

  useEffect(() => {
    /* Was: .map() on a possibly-undefined availableFields, then .push() onto the
       undefined result - a resource with aggregations but no fields yet threw here. */
    let availableFieldsSet = (props?.selectedResource?.availableFields || []).map((af) => af);

    props?.selectedResource?.aggregation?.row?.forEach((a, k) => {
      availableFieldsSet.push({
        fieldName: a.displayName,
        checked: true,
        id: Math.floor(Math.random() * 10000) + 1,
        dataType: "number",
      });
    });
    setFields(availableFieldsSet);
  }, [props]);

  const [activeTab, setActiveTab] = useState("global");

  /* The value control for one data filter, typed by the filter's data type. `key` is
     "value" for a single-value filter, or "value1" / "value2" for the two ends of a
     Between. Restores the inputs the redesign dropped - without them every data filter
     saved with a null value.

     Date fields follow the column's own format: if the resource declares a format with
     an hour component the picker shows a time selector too, so the saved string matches
     what the column actually holds. */
  const renderDataFilterValue = (fi, key) => {
    const onChange = (val) => updateDataFilter(fi, key, val);
    const current = fi[key];

    switch (fi.dataType) {
      case "number":
        return (
          <Input type="number" placeholder="Value" value={current ?? ""} onChange={(e) => onChange(e.target.value)} />
        );

      case "date": {
        const format = dateTimeFormatChange.getDateFormat(fi.fieldName).dateAndTimeFormat;
        return (
          <DatePicker
            style={{ width: "100%" }}
            /* Was `moment()` when unset, which put today's date in the box for a filter
               that had no value - an unset filter looked configured. */
            value={current ? moment(current) : null}
            showTime={format === DATE_WITH_HOUR_FORMAT || format === DATE_WITH_HOUR_MINUTES_FORMAT}
            format={format}
            onChange={(date, dateString) => onChange(dateString)}
          />
        );
      }

      /* Not offered by the Data Type select, but boards saved earlier can carry it:
         a dropdown of the distinct values already present in the column. */
      case "select":
        return (
          <Select
            dropdownMatchSelectWidth={false}
            dropdownStyle={WIDE_DROPDOWN}
            style={{ width: "100%" }}
            value={current}
            onChange={onChange}
          >
            {[...new Set((props.reportDataObject || []).map((rd) => rd[fi.fieldName]))].map((o) => (
              <Option key={o} value={o}>
                {o}
              </Option>
            ))}
          </Select>
        );

      default:
        return <Input placeholder="Value" value={current ?? ""} onChange={(e) => onChange(e.target.value)} />;
    }
  };

  return (
    <div className="data-filter-wrapper">
      {/* Tab toggle */}
      {props.connectionType === "Rest API" ? (
        <div className="filter-tab-group">
          <button
            className={`filter-tab-btn ${activeTab === "global" ? "active" : ""}`}
            onClick={() => setActiveTab("global")}
          >
            Global Filters
          </button>
          <button
            className={`filter-tab-btn ${activeTab === "data" ? "active" : ""}`}
            onClick={() => setActiveTab("data")}
          >
            Data Filters
          </button>
        </div>
      ) : null}

      {/* ── GLOBAL FILTERS ── */}
      {activeTab === "global" && props.connectionType === "Rest API" ? (
        <div>
          {definedFilters.map((defltr) => (
            <div key={"defltr_" + defltr.id} className="filter-row">
              <div className="filter-row-grid">
                <div className="filter-field">
                  <label>Parameter Type</label>
                  <Select
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={WIDE_DROPDOWN}
                    value={defltr.parameterType}
                    onChange={(val) => updateDefinedFilter(defltr, "parameterType", val)}
                  >
                    <Option value="body">Body</Option>
                    <Option value="query">Query</Option>
                  </Select>
                </div>
                <div className="filter-field">
                  <label>Parameter Name</label>
                  <Input
                    placeholder="Name"
                    value={defltr.parameterName}
                    onChange={(e) => updateDefinedFilter(defltr, "parameterName", e.target.value)}
                  />
                </div>
                <div className="filter-field">
                  <label>Data Type</label>
                  <Select
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={WIDE_DROPDOWN}
                    value={defltr.dataType}
                    onChange={(val) => updateDefinedFilter(defltr, "dataType", val)}
                  >
                    <Option value="text">Text</Option>
                    <Option value="number">Number</Option>
                    <Option value="date">Date</Option>
                    <Option value="strArray">Str Array</Option>
                    <Option value="numArray">Num Array</Option>
                  </Select>
                </div>
              </div>

              {/* Max Length / Min+Max / Date range.
                  These bound what the end user may enter in the runtime filter widget.
                  Every input here was previously value-only with no onChange, so none
                  of it could actually be set. */}
              {defltr.dataType === "number" ? (
                <div className="filter-row-grid-wide">
                  <div className="filter-field">
                    <label>Min</label>
                    <Input
                      type="number"
                      placeholder="Min"
                      value={defltr.config?.min}
                      onChange={(e) => updateDefinedFilter(defltr, "min", e.target.value)}
                    />
                  </div>
                  <div className="filter-field">
                    <label>Max</label>
                    <Input
                      type="number"
                      placeholder="Max"
                      value={defltr.config?.max}
                      onChange={(e) => updateDefinedFilter(defltr, "max", e.target.value)}
                    />
                  </div>
                </div>
              ) : defltr.dataType === "date" ? (
                <div className="filter-row-grid-wide">
                  <div className="filter-field">
                    <label>Range</label>
                    <Select
                      dropdownMatchSelectWidth={false}
                      dropdownStyle={WIDE_DROPDOWN}
                      value={defltr.config?.range || "dynamic"}
                      onChange={(val) => updateDefinedFilter(defltr, "dynamicDateRange", val)}
                    >
                      <Option value="dynamic">Dynamic</Option>
                      <Option value="fixedBefore">Fixed - Before</Option>
                      <Option value="fixedAfter">Fixed - After</Option>
                    </Select>
                  </div>
                  <div className="filter-field">
                    <label>{(defltr.config?.range || "dynamic") === "dynamic" ? "Window" : "Date"}</label>
                    {/* A rolling window is a named preset; a fixed boundary is a real
                        date, so the control swaps with the mode. */}
                    {(defltr.config?.range || "dynamic") === "dynamic" ? (
                      <Select
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={WIDE_DROPDOWN}
                        value={defltr.config?.value || "LastMonth"}
                        onChange={(val) => updateDefinedFilter(defltr, "dynamicDateRangeValue", val)}
                      >
                        <Option value="LastWeek">Last Week</Option>
                        <Option value="Last2Weeks">Last 2 Weeks</Option>
                        <Option value="LastMonth">Last Month</Option>
                        <Option value="LastQuarter">Last Quarter</Option>
                        <Option value="Last6Months">Last 6 Months</Option>
                        <Option value="LastYear">Last Year</Option>
                        <Option value="Any">Any</Option>
                      </Select>
                    ) : (
                      <DatePicker
                        style={{ width: "100%" }}
                        format={DATE_FORMAT}
                        value={defltr.config?.value ? moment(defltr.config.value) : null}
                        onChange={(date, dateString) =>
                          updateDefinedFilter(defltr, "dynamicDateRangeValue", dateString)
                        }
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="filter-field">
                  <label>Max Length</label>
                  <Input
                    type="number"
                    placeholder="Max Length"
                    value={defltr.config?.maxLength}
                    onChange={(e) => updateDefinedFilter(defltr, "maxLength", e.target.value)}
                  />
                </div>
              )}

              <div className="filter-field-full">
                <Button type="text" className="filter-remove-btn" onClick={() => deleteDefinedFilterItem(defltr)}>
                  <img src={DeleteIcon} alt="delete-icon" /> Remove
                </Button>
              </div>
            </div>
          ))}
          <Button type="link" className="filter-add-btn" onClick={setDefinedFiltertem}>
            + Add New
          </Button>
        </div>
      ) : null}

      {/* ── DATA FILTERS ── */}
      {activeTab === "data" || props.connectionType !== "Rest API" ? (
        <div>
          {dataFilters.map((fi) => (
            <div key={"fil_" + fi.id} className="filter-row">
              <div className="filter-row-grid">
                <div className="filter-field">
                  <label>Field Name</label>
                  <Select
                    showSearch
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={WIDE_DROPDOWN}
                    placeholder="Select"
                    value={fi.fieldName}
                    onChange={(val) => updateDataFilter(fi, "fieldName", val)}
                  >
                    {fields?.map((af, j) => (
                      <Option value={af.fieldName} key={fi.id + "_" + j}>
                        {af.fieldName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="filter-field">
                  <label>Data Type</label>
                  <Select
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={WIDE_DROPDOWN}
                    value={fi.dataType}
                    onChange={(val) => updateDataFilter(fi, "dataType", val)}
                  >
                    <Option value="string">String</Option>
                    <Option value="number">Number</Option>
                    <Option value="date">Date</Option>
                  </Select>
                </div>
                <div className="filter-field">
                  <label>Filter Type</label>
                  {/* lte / gte were dropped in the redesign; the runtime still offers
                      both, so a filter using them could not be configured here. */}
                  <Select
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={WIDE_DROPDOWN}
                    value={fi.filterType}
                    onChange={(val) => updateDataFilter(fi, "filterType", val)}
                  >
                    <Option value="equal">Equal</Option>
                    {fi.dataType !== "string" && (
                      <>
                        <Option value="lt">Less Than</Option>
                        <Option value="gt">Greater Than</Option>
                        <Option value="lte">Less Than Or Equal</Option>
                        <Option value="gte">Greater Than Or Equal</Option>
                        <Option value="between">Between</Option>
                      </>
                    )}
                    {fi.dataType === "string" && <Option value="con">Contains</Option>}
                  </Select>
                </div>
              </div>

              {/* Value. Between needs two, so the single field becomes From / To. */}
              {fi.filterType === "between" ? (
                <div className="filter-row-grid-wide">
                  <div className="filter-field">
                    <label>From Value</label>
                    {renderDataFilterValue(fi, "value1")}
                  </div>
                  <div className="filter-field">
                    <label>To Value</label>
                    {renderDataFilterValue(fi, "value2")}
                  </div>
                </div>
              ) : (
                <div className="filter-field">
                  <label>Value</label>
                  {renderDataFilterValue(fi, "value")}
                </div>
              )}

              <div className="filter-field-full">
                <Input
                  placeholder="Display Name"
                  value={fi.displayName}
                  onChange={(e) => updateDataFilter(fi, "displayName", e.target.value)}
                  style={{ flex: 1 }}
                />
                <Button className="filter-remove-btn" onClick={() => deleteDataFilterItem(fi)}>
                  <img src={DeleteIcon} alt="delete-icon" /> Remove
                </Button>
              </div>
            </div>
          ))}

          <Button type="link" className="filter-add-btn" onClick={setDataFiltertem}>
            + Add New
          </Button>
        </div>
      ) : null}
      <div className="filter-actions">
        <Button type="primary" onClick={() => saveFilters(dataFilters, definedFilters)}>
          Save Filters
        </Button>
        <Button onClick={clearFilters}>Reset</Button>
      </div>
    </div>
  );
}
